export const getTodayDateRange = () => {
	const now = new Date(); // Pega a data e hora atual no fuso local do navegador

	// Define o início do dia DE HOJE no fuso local
	const startOfDayLocal = new Date(
		now.getFullYear(),
		now.getMonth(),
		now.getDate(),
		0,
		0,
		0,
		0,
	);

	// Define o fim do dia DE HOJE no fuso local
	const endOfDayLocal = new Date(
		now.getFullYear(),
		now.getMonth(),
		now.getDate(),
		23,
		59,
		59,
		999,
	);

	return {
		// .toISOString() converte a data local para o padrão UTC (formato Z)
		// Ex: 10/10 00:00 (UTC-3) vira 2025-10-10T03:00:00.000Z
		date_a: startOfDayLocal.toISOString(),
		date_b: endOfDayLocal.toISOString(),
	};
};

export const getNextDateRange = () => {
	const now = new Date();

	// Define o início de AMANHÃ no fuso local
	const startOfTomorrowLocal = new Date(
		now.getFullYear(),
		now.getMonth(),
		now.getDate() + 1,
		0,
		0,
		0,
		0,
	);

	// Define o fim do dia daqui a 30 dias no fuso local
	const endOfThirtyDaysLaterLocal = new Date(
		now.getFullYear(),
		now.getMonth(),
		now.getDate() + 30,
		23,
		59,
		59,
		999,
	);

	return {
		date_a: startOfTomorrowLocal.toISOString(),
		date_b: endOfThirtyDaysLaterLocal.toISOString(),
	};
};

export const getCurrentMonthDateRange = () => {
	const now = new Date();

	const startOfMonthLocal = new Date(
		now.getFullYear(),
		now.getMonth(),
		1,
		0,
		0,
		0,
		0,
	);

	const endOfMonthLocal = new Date(
		now.getFullYear(),
		now.getMonth() + 1,
		0,
		23,
		59,
		59,
		999,
	);

	return {
		date_a: startOfMonthLocal.toISOString(),
		date_b: endOfMonthLocal.toISOString(),
	};
};

export const getCurrentWeekDateRange = () => {
	const now = new Date();
	const dayOfWeek = now.getDay();

	const startOfWeekLocal = new Date(
		now.getFullYear(),
		now.getMonth(),
		now.getDate() - dayOfWeek,
		0,
		0,
		0,
		0,
	);

	const endOfWeekLocal = new Date(
		startOfWeekLocal.getFullYear(),
		startOfWeekLocal.getMonth(),
		startOfWeekLocal.getDate() + 6,
		23,
		59,
		59,
		999,
	);

	return {
		date_a: startOfWeekLocal.toISOString(),
		date_b: endOfWeekLocal.toISOString(),
	};
};

export const getUserHomeUpcomingSessionsDateRange = () => {
	const now = new Date();

	const startOfDayLocal = new Date(
		now.getFullYear(),
		now.getMonth(),
		now.getDate(),
		0,
		0,
		0,
		0,
	);

	const endInTwelveMonthsLocal = new Date(
		now.getFullYear(),
		now.getMonth() + 12,
		now.getDate(),
		23,
		59,
		59,
		999,
	);

	return {
		date_a: startOfDayLocal.toISOString(),
		date_b: endInTwelveMonthsLocal.toISOString(),
	};
};
